<template>
  <v-system-bar
    app
    color="#ffffff"
    :height="STYLES.APP_BAR_HEIGHT"
    class="sm__system-bar"
  >
    <v-img
      alt="smooth-e Logo"
      src="/resources/system-bar/smooth-e__color_logotype_name.png"
      :width="240"
      :height="40"
      position="left"
      class="mr-2 ml-4 my-2"
    />

    <v-btn
      v-if="firstBtn"
      variant="text"
      :height="24"
      @click="$emit('click-first-btn')"
      class="sm__system-bar-btn ml-5"
      :prepend-icon="firstBtn.icon"
    >
      <template #prepend>
        <v-icon
          size="x-large"
          class="sm__system-bar-btn-icon"
          style="opacity :1;"
        />
      </template>
      <sm-text
        :text="firstBtn.text"
        format="sm__btn-mini"
        color="black"
      />
    </v-btn>
    <v-btn
      v-if="secondBtn"
      variant="text"
      :height="24"
      @click="$emit('click-second-btn')"
      class="sm__system-bar-btn"
      :prepend-icon="secondBtn.icon"
    >
      <template #prepend>
        <sm-badge
          dot
          :visible="secondBadgeVisible"
        >
          <v-icon
            size="x-large"
            class="sm__system-bar-btn-icon"
            style="opacity :1;"
          />
        </sm-badge>
      </template>
      <sm-text
        :text="secondBtn.text"
        format="sm__btn-mini"
        color="black"
      />
    </v-btn>
  </v-system-bar>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import { defineAsyncComponent, PropType } from 'vue'
import { STYLES } from '@/constants/styles'

@Component({
  components: {
    SmText: defineAsyncComponent(() => import('@/components/atoms/SmText.vue')),
    SmBadge: defineAsyncComponent(() => import('@/components/molecules/SmBadge.vue'))
  },
  emits: ['click-first-btn', 'click-second-btn']
})
export default class SmAppBar extends Vue {
  STYLES = Object.freeze(STYLES)

  @Prop({ type: Object as PropType<{ icon: string, text: string }> })
  private readonly firstBtn?: { icon: string, text: string }

  @Prop({ type: Object as PropType<{ icon: string, text: string }> })
  private readonly secondBtn?: { icon: string, text: string }

  @Prop({ type: Boolean, default: false })
  private readonly secondBadgeVisible!: boolean
}

</script>

<style scoped>
.sm__system-bar {
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.13);
  padding: 0 4px;
}
.sm__system-bar .sm__system-bar-btn .sm__system-bar-btn-icon {
  color: #000000;
}
.sm__system-bar :deep(.sm__system-bar-btn) {
  min-width: 64px;
  padding: 0 12px;
  text-indent: 0rem;
}

.sm__system-bar :deep(.sm__system-bar-btn-icon) {
  margin: 0;
}

</style>
